module.exports = __webpack_public_path__ + "img/Mail.304035b4.png";